import { EXCHANGE } from '@/constants';

export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  account: (state) => state.account,
  balances: (state) => state.balances,
  wallets: (state) => {
    if (state.account) {
      return state.account.individual_master_data.wallets.map((w) => w.wallet);
    }
    return [];
  },
  tokenEurc: (state) => {
    if (!state.balances) {
      return 0;
    }
    return sumToken(state.balances, EXCHANGE.TOKENS.EURC);
  },
  tokenUsdc: (state) => {
    if (!state.balances) {
      return 0;
    }
    return sumToken(state.balances, EXCHANGE.TOKENS.USDC);
  },
};

const sumToken = (balances, denom) => {
  let total = 0;
  for (const balance of balances) {
    if (!balance.coins || !balance.coins.length) {
      continue;
    }
    const coin = balance.coins.find((coin) => coin.denom === denom);
    if (coin) {
      total += parseInt(coin.amount);
    }
  }
  return total;
};
